import React, { Component, createRef, RefObject } from 'react';
import Nav from './Nav';
import Headroom from 'react-headroom';
import { AppState } from 'core/redux/reducers';
import { connect } from 'react-redux';
import NavMenu from './Nav/NavMenu';
import ownDoc from 'dom-helpers/ownerDocument';
import classNames from 'classnames';
import {
  actions,
  makeSelectNavIsActive,
  makeSelectNavIsHidden,
  MenuStatus,
  NavTypes,
} from 'core/redux/features/shared/nav';
import qsa from 'dom-helpers/querySelectorAll';

const mapStateToProps = () => {
  const selectNav = makeSelectNavIsHidden();
  const selectNavIsHide = makeSelectNavIsActive();
  return (state: AppState, props: IOwnProps) => {
    return {
      deviceType: state.deviceType,
      navActive: state.nav.active,
      isHidden: selectNav(state, props.menuId),
      activeViewType: state.viewTypes.activeViewType,
      viewInfo: state.products.viewInfo,
      hideMenu: selectNavIsHide(state, NavTypes.Menu),
    };
  };
};

const mapDispatchToProps = {
  updateMenuStatus: actions.updateStatus,
};

interface IOwnProps {
  menuId?: string;
  hideMiniFilter?: boolean;
  showBack?: boolean;
  className?: string;
  // navActive: boolean
  // deviceType: DeviceType
  // activeViewType: string
  // viewInfo: boolean
}

interface IState {
  miniFilterFixed: boolean;
  isPined: boolean;
  autoHide: boolean;
  forcePin: boolean;
  hiddenMiniFilter: boolean;
}

type TProps = IOwnProps &
  ReturnType<ReturnType<typeof mapStateToProps>> &
  typeof mapDispatchToProps;

class HeaderComponent extends Component<TProps, IState> {
  static defaultProps = {
    menuId: 'all',
    hideMiniFilter: false,
    showBack: false,
    className: '',
  };
  state = {
    miniFilterFixed: false,
    isPined: false,
    autoHide: true,
    forcePin: false,
    hiddenMiniFilter: true,
  };
  ownDoc: HTMLDocument;
  private readonly ref: RefObject<Headroom> = createRef();

  componentDidMount(): void {
    const $el = qsa(ownDoc(), '#eb-nav-root-preload');
    if ($el.length > 0) {
      $el[0].parentNode.removeChild($el['0']);
    }

    if (this.ref.current) {
      // @ts-ignore
      this.ref.current.pin();
    }

    this.ownDoc = ownDoc();

    const autoHide = this.detectAutoHide();
    if (!autoHide) {
      this.detectForcePin(this.props);
    }
  }

  componentDidUpdate(
    prevProps: Readonly<TProps>,
    prevState: Readonly<{}>,
    snapshot?: any,
  ): void {
    const autoHide = this.detectAutoHide();
    if (!autoHide) {
      this.detectForcePin(prevProps);
    }
  }

  onToggleActive = (isActive: boolean) => {
    this.setState({ hiddenMiniFilter: isActive });
  };

  render() {
    const {
      props: {
        isHidden,
        hideMiniFilter,
        menuId,
        deviceType,
        showBack,
        className,
      },
      state: { autoHide: disableHead, hiddenMiniFilter },
    } = this;
    return (
      <>
        <Headroom
          // parent={this.detectParent}
          downTolerance={10}
          upTolerance={10}
          onUnfix={() => this.onToggleUnFixed(true)}
          onUnpin={() => this.onTogglePin(false)}
          onPin={() => this.onTogglePin(true)}
          disable={disableHead || hideMiniFilter || deviceType !== 'mobile'}
          className={classNames(
            className,
            `menu-${menuId}`,
            isHidden && deviceType === 'mobile' && 'hide',
            disableHead ? 'headroom--disabled' : '',
            !hiddenMiniFilter && `headroom--filter`,
          )}
          ref={this.ref}
          disableInlineStyles={true}
        >
          <Nav showBack={showBack} />
        </Headroom>
        <NavMenu />
      </>
    );
  }

  private detectAutoHide = () => {
    const { deviceType, activeViewType, viewInfo, navActive } = this.props;
    const autoHide =
      deviceType === 'desktop' ||
      (deviceType === 'mobile' &&
        (activeViewType === 'map' || viewInfo || navActive));

    if (this.state.autoHide !== autoHide) {
      this.setState({ autoHide });
      this.setState({ forcePin: false });
    }

    return autoHide;
  };

  private detectForcePin = (prevProps: Readonly<TProps>) => {
    const { viewInfo, activeViewType, deviceType, navActive } = this.props;

    if (this.state.forcePin) {
      return;
    }

    if (
      deviceType === 'mobile' &&
      !this.state.forcePin &&
      (navActive !== prevProps.navActive ||
        activeViewType !== prevProps.activeViewType ||
        viewInfo !== prevProps.viewInfo)
    ) {
      // @ts-ignore
      this.ref.current.pin();
      this.setState({ forcePin: true });
      this.props.updateMenuStatus(this.props.menuId, MenuStatus.pin);
    }
  };

  private onTogglePin = (isPined: boolean) => {
    this.setState({ isPined });
    this.setState({ forcePin: false });
    if (this.state.miniFilterFixed === false) {
      this.setState({ miniFilterFixed: true });
    }

    if (isPined) {
      this.props.updateMenuStatus(this.props.menuId, MenuStatus.pin);
    } else {
      this.props.updateMenuStatus(this.props.menuId, MenuStatus.unpin);
    }
  };

  private onToggleUnFixed = (isFixedNav: boolean) => {
    this.setState({ miniFilterFixed: !isFixedNav });
    this.props.updateMenuStatus(this.props.menuId, MenuStatus.unfixed);
  };
}

const Header = connect(mapStateToProps, mapDispatchToProps)(HeaderComponent);

export default Header;
